import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
@Component({
  selector: 'app-product-search-dialog',
  imports: [
    MatInputModule,
    FormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
  ],
  templateUrl: './product-search-dialog.html',
  styleUrl: './product-search-dialog.scss',
})
export class ProductSearchDialog implements OnInit {
  query: string = '';
  history: string[] = [];
  constructor(
    private dialog: MatDialogRef<ProductSearchDialog>,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadHistory();
  }

  async loadHistory() {
    try {
      const history = localStorage.getItem('searchHistory') ?? '';
      const r = JSON.parse(history);
      if (r instanceof Array) {
        this.history = r;
      }
    } catch (error) {}
  }

  async saveHistory() {
    try {
      localStorage.setItem('searchHistory', JSON.stringify(this.history));
    } catch (error) {}
  }

  search() {
    this.query = this.query.trim();
    this.dialog.close(this.query);
    this.router.navigate(['/search'], { queryParams: { q: this.query } });
    if (!this.query) {
      return;
    }
    if (this.history.indexOf(this.query) === -1) {
      this.history.unshift(this.query);
    } else {
      this.history.splice(this.history.indexOf(this.query), 1);
      this.history.unshift(this.query);
    }
    if (this.history.length > 10) {
      this.history = this.history.slice(0, 10);
    }
    this.saveHistory();
  }
}
